'use client'

import { useEffect } from "react";

/**
 * Remembers the city the visitor is currently browsing by writing a non-sensitive
 * preference cookie. Runs on every /[location] page (rendered by the location
 * layout), so BOTH explicit switches and direct shared-link visits are captured.
 * The root "/" reads this cookie to send returning visitors back to their city.
 * Renders nothing.
 */
export function RememberLocation({ slug }: { slug: string }) {
  useEffect(() => {
    // `secure` since the site has been HTTPS-only (commit 5cac2dc). Note this
    // value is user-writable by definition — anything reading it server-side must
    // validate it, which is what resolvePreferredLocation() is for.
    document.cookie = `loc=${encodeURIComponent(slug)}; path=/; max-age=31536000; samesite=lax; secure`;
  }, [slug]);
  return null;
}
